module.exports = __webpack_public_path__ + "img/shield-lock.0a86261d.png";